import React from 'react';
import PropTypes from 'prop-types';

import Page from '../Page';
import InternalLink from '../InternalLink';

const selected = ({ hash, pathname }) =>
  (pathname === '/' && hash === '') ||
  (pathname === '' && hash === '') ||
  hash.slice(1) === 'home';

const Header = props => {
  const { location, siteMotto, title } = props;
  return (
    <Page {...props} isSelected={selected(location)} tag="header">
      <div className="title-block">
        <h1 className="wordmark">
          <InternalLink slug="home">{title}</InternalLink>
        </h1>
        <h2 className="motto">{siteMotto}</h2>
      </div>
      <p>Hello!</p>
      <p>
        I am an independent web designer and developer working and living in
        Portland, Ore.
      </p>
      <p>
        Be it whole websites or user interface design,{' '}
        <InternalLink slug="craft">I hand-craft experiences</InternalLink> that
        are{' '}
        <InternalLink slug="methodology">
          user-centric, reduce friction and delight with serendipitity
        </InternalLink>
        .
      </p>
      <p>
        Feel free to{' '}
        <InternalLink slug="about-me">find out more about me</InternalLink>,{' '}
        <InternalLink slug="clients">who hires me</InternalLink>,{' '}
        <InternalLink slug="services">how I can help</InternalLink>, or see some
        of the{' '}
        <InternalLink slug="projects">
          projects I’ve completed recently
        </InternalLink>
        . Or perhaps you’re{' '}
        <InternalLink slug="pricing">wondering about cost</InternalLink> and/or{' '}
        <InternalLink slug="every-website">
          what you get when you hire me
        </InternalLink>
        . Are you{' '}
        <InternalLink slug="every-website">
          interested in this website
        </InternalLink>
        ? Whatever the case, if you have any questions I encourage you to simply{' '}
        <InternalLink slug="contact">contact me</InternalLink>.
      </p>
    </Page>
  );
};

Header.propTypes = {
  featured: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  siteMotto: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

Header.defaultProps = {
  featured: [
    {
      className: 'background',
      filepath: 'logo/jack',
      key: 'jack',
      scale: [
        {
          atSize: '2x',
          width: 1024,
        },
        {
          atSize: '3x',
          width: 1536,
        },
        {
          atSize: '4x',
          width: 2048,
        },
      ],
      style: {
        top: 0,
        right: '-12vh',
        opacity: 0.05,
        maxHeight: '100%',
      },
    },
  ],
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js